import { render, staticRenderFns } from "./customer-sample-list.vue?vue&type=template&id=148a0491&"
import script from "./customer-sample-list.vue?vue&type=script&lang=js&"
export * from "./customer-sample-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports